export default __webpack_public_path__ + "static/bg-zappi--mobile-35e6c37d4cac6dda025b9828b1a43c32.jpg";